import React, { useEffect, useRef, useState } from 'react';
// import { reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { jsonEditorStyles } from '../jsonEditorStyles';
import Button from '@mui/material/Button';
import cn from 'clsx';
import useComponentUIHook from './useComponentUIHook';
import { SelectComponent, TextComponent, TooltipComponent } from '../../uiComponents';
import { SelectChangeEvent } from '@mui/material';
import { OptionProps } from '../../../view-models';
import DeleteIcon from '@mui/icons-material/Delete';
import ModeEditOutlineSharpIcon from '@mui/icons-material/ModeEditOutlineSharp';
import { cloneDeep } from 'lodash';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import SessionManagement, { sessionFieldsAreValid } from './sessionManagement';
import jsonComponents from '../../../constants/jsonComponents';
import { FieldMapperRow } from './fieldMapperRow';
import { resolverStringValid } from './resolverSelector';
import TemplatizedFieldComponent, { getTemplatizedValue, TemplatizedValue } from './templatizedFieldComponent';
import jsonConstants from '../../../constants/jsonConstants';

const styles = makeStyles((theme: Theme) =>
  createStyles({
    flexCol: {
      display: 'flex',
      flexDirection: 'column',
    },
    flexColfill: {
      display: 'flex',
      flexDirection: 'column',
      flexBasis: '100%',
      flex: '1',
      padding: '2px',
      overflow: 'hidden',
      '& .inline-tooltip': {
        marginTop: '10px',
      },
    },
    flexRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
    },

    attributeData: {
      wordBreak: 'break-all',
    },
    attribute: {
      borderBottom: '1px solid grey',
      padding: 10,
    },
    pointer: {
      cursor: 'pointer',
    },
    icon: {
      cursor: 'pointer',
      marginLeft: '0.5rem',
    },
    justifyContent: {
      justifyContent: 'space-between',
    },
    marginRight: { marginRight: '20px' },
    marginLeft: { marginLeft: '10px' },
  }),
);

interface componentProps {
  componentData: any;
  closeGritComponent: any;
  setUnsavedChanges: any;
}
const GenerateRestAPIUI = ({ componentData, closeGritComponent, setUnsavedChanges }: componentProps) => {
  const { modifiedData, setModifiedData, checkIfSameIgnoringSubFlows, allClaims, modifiedTemplatizations, setModifiedTemplatizations } = useComponentUIHook(componentData);

  // for addParameter
  const initParameter = useRef(componentData['parameter']);
  const [claimsList, setClaimsList] = useState<OptionProps[]>([]);
  const [paramNameError, setParamNameError] = useState<string>('');
  const [updateParam, setUpdateParam] = useState<boolean>(false);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const configData = jsonComponents.restAPI.data;
  const classes = styles();
  const classes1 = jsonEditorStyles();

  useEffect(() => {
    if (Object.keys(allClaims).length > 0) {
      const _temp = Object.keys(allClaims)
        .reduce((acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }), [])
        .sort((a: OptionProps, b: OptionProps) => (a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1));
      setClaimsList(_temp);
    }
  }, [allClaims]);

  useEffect(() => {
    const _res: boolean = checkIfSameIgnoringSubFlows();
    setDisableSubmit(_res ||
      (getTemplatizedValue(modifiedData['serviceUrl']).trim() === '') ||
      (modifiedData['authenticationType'] === '') ||
      ((modifiedData['authenticationType'] === 'aadBearer') &&
        ((getTemplatizedValue(modifiedData['clientIdContainer']).trim() === '') ||
          (getTemplatizedValue(modifiedData['clientSecretContainer']).trim() === '') ||
          (getTemplatizedValue(modifiedData['issuerTenant']).trim() === '') ||
          (getTemplatizedValue(modifiedData['applicationIdUri']).trim() === ''))) ||
      ((modifiedData['authenticationType'] === 'clientCert') &&
        (getTemplatizedValue(modifiedData['clientCertContainer']).trim() === '')) ||
      (!sessionFieldsAreValid(modifiedData))
    );
    setUnsavedChanges(_res);
  }, [modifiedData]);

  const onEditHandler = (parameter: any) => {
    setUpdateParam(true);
    setModifiedData({
      ...modifiedData,
      parameter: parameter,
    });
  };

  const onDeleteHandler = (parameterName: string, type: string) => {
    const _parameters = modifiedData['parameters'].reduce((acc: any[], item: any) => {
      return parameterName === item['parameterName'] && type === item['type'] ? acc : acc.concat(item);
    }, []);

    setModifiedData({
      ...modifiedData,
      parameters: _parameters,
    });
    setUpdateParam(false);
  };

  const processParameter = (data: any) => {
    const obj: any = {};
    obj['type'] = data['type'];
    obj['parameterName'] = data['parameterName'];
    obj['claimName'] = data['claimName'];
    obj['defaultValue'] = data['defaultValue'];
    obj['alwaysUseDefaultValue'] = data['alwaysUseDefaultValue'];
    obj['sourceType'] = data['sourceType'];
    return obj;
  };
  const submitData = (data: any) => {
    closeGritComponent(data, modifiedTemplatizations);
  };
  return (
    <div className={classes.flexCol}>
      <div className={classes.flexRow}>
        <div>
          <TemplatizedFieldComponent
            changeHandler={(e: TemplatizedValue) => {
              setModifiedData({ ...modifiedData, serviceUrl: {...e}});
            }}
            modifiedTemplatizations={modifiedTemplatizations}
            setModifiedTemplatizations={setModifiedTemplatizations}
            data={{
              fieldPath: 'serviceUrl',
              label: 'Service Url',
              style: { marginLeft: 1, width: 600 },
              required: true,
              value: getTemplatizedValue(modifiedData['serviceUrl']),
              variant: 'text'
            }}
          />
        </div>
      </div>
      <div className={classes.flexRow}>
        <SelectComponent
          changeHandler={(e: SelectChangeEvent<string>) => {
            setModifiedData({ ...modifiedData, sendClaimsIn: e.target.value });
          }}
          data={{
            value: modifiedData['sendClaimsIn'] ? modifiedData['sendClaimsIn'] : 'body',
            label: 'Claim Sending Method',
            options: [
              { value: 'body', label: 'Request Body (JSON)' },
              { value: 'form', label: 'Request Body (Form-encoded)' },
              { value: 'header', label: 'Header' },
              { value: 'url', label: 'In URL' },
              { value: 'queryString', label: 'URL Query Parameters'}
            ],
            style: { margin: 1, width: 500 },
          }}
        />
      </div>
      <div className={classes.flexRow}>
        <div className={classes.flexCol}>
          <SelectComponent
            changeHandler={(e: SelectChangeEvent<string>) => {
              setModifiedData({ ...modifiedData, authenticationType: e.target.value });
            }}
            data={{
              value: modifiedData['authenticationType'] ? modifiedData['authenticationType'] : '',
              label: 'Authentication Type',
              options: jsonConstants.enableRestClientCertAuth ? [
                { value: 'none', label: 'None' },
                { value: 'aadBearer', label: 'Azure AD Bearer Token' },
                { value: 'clientCert', label: 'Client Certificate' }
              ] : [
                { value: 'none', label: 'None' },
                { value: 'aadBearer', label: 'Azure AD Bearer Token' }
              ],
              style: { margin: 1, width: 250 },
            }}
          />
          {(modifiedData['authenticationType'] === 'aadBearer') && (
            <>
              <div className={classes.flexRow}>
                <TemplatizedFieldComponent
                  changeHandler={(e: TemplatizedValue) => {
                    setModifiedData({ ...modifiedData, issuerTenant: { ...e } });
                  }}
                  modifiedTemplatizations={modifiedTemplatizations}
                  setModifiedTemplatizations={setModifiedTemplatizations}
                  data={{
                    fieldPath: 'issuerTenant',
                    label: 'Token Issuer Tenant',
                    style: { marginLeft: 1, width: 600 },
                    required: true,
                    value: getTemplatizedValue(modifiedData['issuerTenant']),
                    variant: 'text'
                  }}
                />
                <TooltipComponent
                  title='Token Issuer Tenant'
                  desc='The tenant domain (such as tenantname.onmicrosoft.com) where the application registration protecting the API resides.'
                />
              </div>
              <div className={classes.flexRow}>
                <TemplatizedFieldComponent
                  changeHandler={(e: TemplatizedValue) => {
                    setModifiedData({ ...modifiedData, applicationIdUri: { ...e } });
                  }}
                  modifiedTemplatizations={modifiedTemplatizations}
                  setModifiedTemplatizations={setModifiedTemplatizations}
                  data={{
                    fieldPath: 'applicationIdUri',
                    label: 'Application ID URI',
                    style: { marginLeft: 1, width: 600 },
                    required: true,
                    value: getTemplatizedValue(modifiedData['applicationIdUri']),
                    variant: 'text'
                  }}
                />
                <TooltipComponent
                  title='Application ID URI'
                  desc='The Application ID URI for the AAD application registration protecting the API.'
                />
              </div>
              <div className={classes.flexRow}>
                <TemplatizedFieldComponent
                  changeHandler={(e: TemplatizedValue) => {
                    setModifiedData({ ...modifiedData, clientIdContainer: { ...e } });
                  }}
                  modifiedTemplatizations={modifiedTemplatizations}
                  setModifiedTemplatizations={setModifiedTemplatizations}
                  data={{
                    fieldPath: 'clientIdContainer',
                    label: 'Client ID',
                    style: { marginLeft: 1, width: 600 },
                    required: true,
                    value: getTemplatizedValue(modifiedData['clientIdContainer']),
                    variant: 'text'
                  }}
                />
                <TooltipComponent
                  title='Client ID Container'
                  desc='The policy key container ID on the tenant containing the client ID to use for fetching the access token'
                />
              </div>
              <div className={classes.flexRow}>
                <TemplatizedFieldComponent
                  changeHandler={(e: TemplatizedValue) => {
                    setModifiedData({ ...modifiedData, clientSecretContainer: { ...e } });
                  }}
                  modifiedTemplatizations={modifiedTemplatizations}
                  setModifiedTemplatizations={setModifiedTemplatizations}
                  data={{
                    fieldPath: 'clientSecretContainer',
                    label: 'Client Secret',
                    style: { marginLeft: 1, width: 600 },
                    required: true,
                    value: getTemplatizedValue(modifiedData['clientSecretContainer']),
                    variant: 'text'
                  }}
                />
                <TooltipComponent
                  title='Client Secret Container'
                  desc='The policy key container ID on the tenant containing the secret to use for fetching the access token'
                />
              </div>
            </>
          )}
          {(modifiedData['authenticationType'] === 'clientCert') && (
            <TemplatizedFieldComponent
              changeHandler={(e: TemplatizedValue) => {
                setModifiedData({ ...modifiedData, clientCertContainer: { ...e } });
              }}
              modifiedTemplatizations={modifiedTemplatizations}
              setModifiedTemplatizations={setModifiedTemplatizations}
              data={{
                fieldPath: 'clientCertContainer',
                label: 'Client Certificate Container',
                style: { marginLeft: 1, width: 600 },
                required: true,
                value: getTemplatizedValue(modifiedData['clientCertContainer']),
                variant: 'text'
              }}
            />
          )}
        </div>
      </div>
      <div className={classes1.subHeading}>Parameters</div>
      <div className={cn(classes.flexRow)}>
        <FieldMapperRow
          rowData={modifiedData['parameter']}
          writeback={(rowData: any) => {
            if (rowData['type'] === 'output' || !rowData['sourceType']) {
              rowData['sourceType'] = 'claim';
            }
            setModifiedData({
              ...modifiedData,
              parameter: rowData,
            });
            if (
              !updateParam &&
              modifiedData['parameters'].findIndex(
                (el: any) =>
                  el['parameterName'].trim().toLowerCase() === rowData['parameterName'] &&
                  el['type'] === rowData['type'],
              ) >= 0
            ) {
              setParamNameError('A parameter exists with the same name');
            } else {
              setParamNameError('');
            }
          }}
          claimsList={claimsList}
          allClaims={allClaims}
          enabledSources={modifiedData['parameter']['type'] === 'input' ? ['claim', 'resolver'] : ['claim']}
          precursorFields={[
            {
              fieldName: 'type',
              fieldType: 'select',
              fieldData: {
                value: modifiedData['parameter']['type'],
                label: 'Type',
                options: [
                  { label: 'input', value: 'input' },
                  { label: 'output', value: 'output' },
                ],
                style: { margin: 1, width: '140px' },
                disabled: updateParam,
                required: true,
              },
            },
          ]}
          sourceTypeFieldName={modifiedData['parameter']['type'] === 'input' ? 'sourceType' : undefined}
          sourceTypeFieldLabel={modifiedData['parameter']['type'] === 'input' ? 'Data Source' : 'Data Destination'}
          fixedSourceType={modifiedData['parameter']['type'] === 'input' ? undefined : 'claim'}
          sourceFieldName="claimName" //TODO: Change this. It will break preexisting JSON/templates, but is a misnomer now.
          sourceFieldLabels={{ claim: 'Claim Name', resolver: 'Session Context' }}
          partnerTypeFieldName="parameterName"
          partnerTypeFieldLabel="API Parameter Name"
          defaultValueFieldName="defaultValue"
          defaultValueFieldLabel="Default Value"
          alwaysUseDefaultValueFieldName="alwaysUseDefaultValue"
          allowEmptyDefaultValue={true}
          buttonText={updateParam ? 'Update' : 'Add'}
          buttonAction={
            updateParam
              ? () => {
                  setModifiedData({
                    ...modifiedData,
                    parameters: cloneDeep(modifiedData['parameters']).reduce(
                      (acc: any, curParam: any) =>
                        modifiedData['parameter']['type'] === curParam['type'] &&
                        modifiedData['parameter']['parameterName'] === curParam['parameterName']
                          ? acc.concat(modifiedData['parameter'])
                          : acc.concat(curParam),
                      [],
                    ),
                    parameter: initParameter.current,
                  });
                  setUpdateParam(false);
                }
              : () => {
                  setModifiedData({
                    ...modifiedData,
                    parameters: [...modifiedData['parameters'], processParameter(modifiedData['parameter'])],
                    parameter: initParameter.current,
                  });
                }
          }
          buttonDisabled={
            modifiedData['parameter']['parameterName'].trim() === '' ||
            paramNameError !== '' ||
            ((!modifiedData['parameter']['sourceType'] || modifiedData['parameter']['sourceType'] === 'claim') &&
              modifiedData['parameter']['claimName'] === '') ||
            (modifiedData['parameter']['sourceType'] === 'resolver' &&
              !resolverStringValid(modifiedData['parameter']['claimName']))
          }
        />
      </div>

      <div className={cn(classes.flexRow, classes.justifyContent)}>
        <div className={cn(classes.flexCol)}>
          {['Input', 'Output'].map((type: string) => {
            return (
              <div key={type}>
                {modifiedData['parameters'].filter((param: any) => param.type === type.toLowerCase()).length > 0 && (
                  <div className={classes1.subHeading}>{type} Parameters</div>
                )}
                {modifiedData['parameters']
                  .filter((param: any) => param.type === type.toLowerCase())
                  .map((attr: any, index: number) => (
                    <div
                      key={attr['parameterName']}
                      className={cn(classes.flexRow, classes.attribute, classes.justifyContent)}
                    >
                      <div className={cn(classes.flexCol, classes.attributeData)}>
                        <div className={classes.flexRow}>
                          <div className={classes.marginRight}>
                            <b>Parameter Name:</b> {attr['parameterName']}
                          </div>
                          <div className={classes.marginRight}>
                            <b>{attr['sourceType'] === 'resolver' ? 'Session Context :' : 'Claim Name :'}</b>{' '}
                            {attr['claimName']}
                          </div>
                          {(!attr['sourceType'] || attr['sourceType'] === 'claim') && (
                            <>
                              <div className={classes.marginRight}>
                                <b>Default Value :</b> {attr['defaultValue']}
                              </div>
                              <div className={classes.marginRight}>
                                <b>Always Use Default Value :</b> {attr['alwaysUseDefaultValue'].toString()}
                              </div>
                            </>
                          )}
                          <div>
                            <ModeEditOutlineSharpIcon
                              onClick={() => onEditHandler(attr)}
                              className={classes.icon}
                              color="primary"
                            />
                          </div>
                          <div>
                            <DeleteIcon
                              onClick={() => {
                                window.confirm(
                                  'Are you sure you want to delete the ' +
                                    attr['type'] +
                                    ' paramter ' +
                                    attr['parameterName'] +
                                    '? This cannot be undone.',
                                ) && onDeleteHandler(attr['parameterName'], type.toLowerCase());
                              }}
                              className={classes.icon}
                              color="error"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            );
          })}

          {configData.sessionManagement && (
            <SessionManagement
              modifiedData={modifiedData}
              changeHandler={(data: any) => setModifiedData(data)}
              sessionTypes={configData.sessionTypes}
            />
          )}
          <div>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={disableSubmit}
              onClick={() => {
                submitData(cloneDeep(modifiedData));
              }}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
// export default withAITracking(reactPlugin, GenerateRestAPIUI);
export default GenerateRestAPIUI;
